import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import {
  setStep,
  setFleetVehicle,
} from '../../../../js/lib/redux/slices/booking'
import constants from '../../../../js/lib/constants'
import Steps from './Steps'

const StepsNavigate = () => {
  const isBooking = window.bookingData ? true : false
  const { pendingPayment } = window.modifyData?.values || {}
  const { step: currentStep, type } = useSelector((state) => state.booking)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const skipPathEffectRef = useRef(false)
  const skipStepEffectRef = useRef(false)

  useEffect(() => {
    if (skipPathEffectRef.current) {
      skipPathEffectRef.current = false
      return
    }

    if (isBooking) {
      if (pathname === constants.booking.navigateTo.vehicles) {
        skipStepEffectRef.current = true
        dispatch(setStep(constants.booking.pageNumber.vehicles))
      } else if (pathname === constants.booking.navigateTo.extras) {
        skipStepEffectRef.current = true
        dispatch(setStep(constants.booking.pageNumber.extras))
      } else if (pathname === constants.booking.navigateTo.payment) {
        skipStepEffectRef.current = true
        dispatch(setStep(constants.booking.pageNumber.payment))
      }
    } else {
      if (
        pathname === constants.modify.navigateTo.modifyCancel ||
        pathname === constants.modify.navigateTo.pendingPayment
      ) {
        skipStepEffectRef.current = true
        dispatch(setStep(constants.modify.pageNumber.modifyCancel))
      } else if (
        pathname === constants.modify.navigateTo.acceptModification ||
        pathname === constants.modify.navigateTo.acceptPendingPayment
      ) {
        skipStepEffectRef.current = true
        dispatch(setStep(constants.modify.pageNumber.acceptModification))
      }
    }
  }, [pathname])

  useEffect(() => {
    if (skipStepEffectRef.current) {
      skipStepEffectRef.current = false
      return
    }

    skipPathEffectRef.current = true

    if (isBooking) {
      switch (currentStep) {
        case constants.booking.pageNumber.vehicles:
          navigate(constants.booking.navigateTo.vehicles)
          break
        case constants.booking.pageNumber.extras:
          navigate(constants.booking.navigateTo.extras)
          break
        case constants.booking.pageNumber.payment:
          navigate(constants.booking.navigateTo.payment)
          break
        default:
          break
      }
    } else {
      switch (currentStep) {
        case constants.modify.pageNumber.modifyCancel:
          pendingPayment
            ? navigate(constants.modify.navigateTo.pendingPayment)
            : navigate(constants.modify.navigateTo.modifyCancel)
          break
        case constants.modify.pageNumber.acceptModification:
          pendingPayment
            ? navigate(constants.modify.navigateTo.acceptPendingPayment)
            : navigate(constants.modify.navigateTo.acceptModification)
          break
        case constants.modify.pageNumber.confirmation:
          navigate(constants.modify.navigateTo.confirmation)
          break
        default:
          break
      }
    }
  }, [currentStep])

  const handleStepClick = (step, index) => {
    if (index === currentStep) return

    if (index === 0) {
      window.location.href = step.path
      return
    }

    if (index === 1 && isBooking) {
      dispatch(setFleetVehicle(null))
    }

    if (index < currentStep) {
      dispatch(setStep(index))
    }
  }

  return (
    <Steps
      currentStep={currentStep}
      type={type}
      handleStepClick={handleStepClick}
    />
  )
}

export default StepsNavigate
